// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120005/js/" + chunkId + "." + {"44":"0bdb3968","225":"6dfcac51","481":"0dae6a5f","486":"a2f8c34c","770":"2730578e"}[chunkId] + ".0.02965265468385192.chunk.js";
};